import { z } from 'zod';
import { TicketStatusSchema } from './ticket-schemas.js';
// admin-analytics-expansion P2a (D4/D5, spec R6, #2559) — cursor-paginated,
// filterable ticket browse list contract. Single source of truth shared by
// AdminTicketBrowseController (backend) and browseTickets() (api-client).
// Mirrors ticket-analytics-schemas.ts conventions (query schema + response
// schema in one file).
export const TicketBrowsePaymentStatusSchema = z.enum(['unpaid', 'paid']);
export const TicketBrowseQuerySchema = z
    .object({
    locationId: z.string().uuid().optional(),
    status: TicketStatusSchema.optional(),
    paymentStatus: TicketBrowsePaymentStatusSchema.optional(),
    from: z.string().datetime().optional(),
    to: z.string().datetime().optional(),
    /** Opaque keyset pagination cursor (base64url) — omit for page 1. */
    cursor: z.string().optional(),
    limit: z.coerce.number().int().min(1).max(100).optional(),
})
    .refine((v) => !v.from || !v.to || new Date(v.from) <= new Date(v.to), {
    message: "'to' must not precede 'from'",
    path: ['to'],
});
// One row of the browse list — a lightweight summary, NOT the full ticket
// aggregate (photos/SMS/membership/payment breakdown are P3's ticket-detail
// concern, D7).
export const TicketBrowseItemSchema = z.object({
    id: z.string().uuid(),
    ticketNumber: z.number().int().positive(),
    locationId: z.string().uuid(),
    plate: z.string(),
    firstName: z.string().nullable(),
    lastName: z.string().nullable(),
    status: TicketStatusSchema,
    paymentStatus: TicketBrowsePaymentStatusSchema,
    ticketType: z.enum(['sms', 'qr']),
    checkedInAt: z.string(), // ISO 8601 UTC
    amountPaidCents: z.number().int().nullable(),
    tipAmountCents: z.number().int().nullable(),
});
export const TicketBrowseResponseSchema = z.object({
    items: z.array(TicketBrowseItemSchema),
    nextCursor: z.string().nullable(),
});
//# sourceMappingURL=ticket-browse-schemas.js.map